import { FAQTopic } from './faq-topics.model';

/**
 * transforms a WebContent API response into an array of FAQ Topics
 * @param webContent - https://gitlab.zipari.net/api-specifications/product-api-specs/-/blob/master/domains/models/web-content/swagger.yaml
 */
export function webContentToFAQTopics(webContent): FAQTopic[] {
  const topics = webContent.entries.map((entry) => ({
    id: entry.id,
    name: entry.title.content,
    faqs: entry.entries.map((e) => ({
      question: e.title.content,
      // the schema mandates an array with both a min and max length of 1
      answer: e.entries[0].title.content,
    })),
  }));

  return topics;
}
